export default __webpack_public_path__ + "static/imgEight-948b1eb614b7e1d1e5d25991d3577456.jpg";